import { type SlidingTextProps } from './SlidingText'

export const SlidingTextDefaultProps = {
  speed: 0.25,
  duration: 3,
  itemStyle: 'Display Heading 1',
  itemColor: 'black',
  items: [
    {
      value: 'Guitar',
    },
    {
      value: 'Ukulele',
    },
    {
      value: 'Piano',
    },
    {
      value: 'Trumpet',
    },
  ],
} satisfies SlidingTextProps
